/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  AddMemberRequest,
  ApiEnvelopeBoolean,
  ApiEnvelopeTenantDto,
  ApiEnvelopeTenantMemberDto,
  ApiEnvelopeTenantMembersResponse,
  ApiEnvelopeTenantSettingsDto,
  TenantSettingsRequest,
  UpdateMemberRoleRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type tenantGetTenantResponse200 = {
  data: ApiEnvelopeTenantDto
  status: 200
}

export type tenantGetTenantResponse400 = {
  data: ApiEnvelopeTenantDto
  status: 400
}

export type tenantGetTenantResponse401 = {
  data: ApiEnvelopeTenantDto
  status: 401
}

export type tenantGetTenantResponse403 = {
  data: ApiEnvelopeTenantDto
  status: 403
}

export type tenantGetTenantResponse404 = {
  data: ApiEnvelopeTenantDto
  status: 404
}

export type tenantGetTenantResponseSuccess = (tenantGetTenantResponse200) & {
  headers: Headers;
};
export type tenantGetTenantResponseError = (tenantGetTenantResponse400 | tenantGetTenantResponse401 | tenantGetTenantResponse403 | tenantGetTenantResponse404) & {
  headers: Headers;
};

export type tenantGetTenantResponse = (tenantGetTenantResponseSuccess | tenantGetTenantResponseError)

export const getTenantGetTenantUrl = (tenantId: string,) => {




  return `/api/tenants/${tenantId}`
}

export const useTenantGetTenantHook = (): (tenantId: string, options?: RequestInit) => Promise<tenantGetTenantResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string, options?: RequestInit) => {

        return customFetcher(getTenantGetTenantUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type tenantGetSettingsResponse200 = {
  data: ApiEnvelopeTenantSettingsDto
  status: 200
}

export type tenantGetSettingsResponse400 = {
  data: ApiEnvelopeTenantSettingsDto
  status: 400
}

export type tenantGetSettingsResponse401 = {
  data: ApiEnvelopeTenantSettingsDto
  status: 401
}

export type tenantGetSettingsResponse403 = {
  data: ApiEnvelopeTenantSettingsDto
  status: 403
}

export type tenantGetSettingsResponse404 = {
  data: ApiEnvelopeTenantSettingsDto
  status: 404
}

export type tenantGetSettingsResponseSuccess = (tenantGetSettingsResponse200) & {
  headers: Headers;
};
export type tenantGetSettingsResponseError = (tenantGetSettingsResponse400 | tenantGetSettingsResponse401 | tenantGetSettingsResponse403 | tenantGetSettingsResponse404) & {
  headers: Headers;
};

export type tenantGetSettingsResponse = (tenantGetSettingsResponseSuccess | tenantGetSettingsResponseError)

export const getTenantGetSettingsUrl = (tenantId: string,) => {




  return `/api/tenants/${tenantId}/settings`
}

export const useTenantGetSettingsHook = (): (tenantId: string, options?: RequestInit) => Promise<tenantGetSettingsResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string, options?: RequestInit) => {

        return customFetcher(getTenantGetSettingsUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type tenantUpdateSettingsResponse200 = {
  data: ApiEnvelopeTenantSettingsDto
  status: 200
}

export type tenantUpdateSettingsResponse400 = {
  data: ApiEnvelopeTenantSettingsDto
  status: 400
}

export type tenantUpdateSettingsResponse401 = {
  data: ApiEnvelopeTenantSettingsDto
  status: 401
}

export type tenantUpdateSettingsResponse403 = {
  data: ApiEnvelopeTenantSettingsDto
  status: 403
}

export type tenantUpdateSettingsResponse404 = {
  data: ApiEnvelopeTenantSettingsDto
  status: 404
}

export type tenantUpdateSettingsResponseSuccess = (tenantUpdateSettingsResponse200) & {
  headers: Headers;
};
export type tenantUpdateSettingsResponseError = (tenantUpdateSettingsResponse400 | tenantUpdateSettingsResponse401 | tenantUpdateSettingsResponse403 | tenantUpdateSettingsResponse404) & {
  headers: Headers;
};

export type tenantUpdateSettingsResponse = (tenantUpdateSettingsResponseSuccess | tenantUpdateSettingsResponseError)

export const getTenantUpdateSettingsUrl = (tenantId: string,) => {




  return `/api/tenants/${tenantId}/settings`
}

export const useTenantUpdateSettingsHook = (): (tenantId: string,
    tenantSettingsRequest?: TenantSettingsRequest, options?: RequestInit) => Promise<tenantUpdateSettingsResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string,
    tenantSettingsRequest?: TenantSettingsRequest, options?: RequestInit) => {

        return customFetcher(getTenantUpdateSettingsUrl(tenantId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tenantSettingsRequest)
  }
);
      }
  }


export type tenantGetMembersResponse200 = {
  data: ApiEnvelopeTenantMembersResponse
  status: 200
}

export type tenantGetMembersResponse400 = {
  data: ApiEnvelopeTenantMembersResponse
  status: 400
}

export type tenantGetMembersResponse401 = {
  data: ApiEnvelopeTenantMembersResponse
  status: 401
}

export type tenantGetMembersResponse403 = {
  data: ApiEnvelopeTenantMembersResponse
  status: 403
}

export type tenantGetMembersResponse404 = {
  data: ApiEnvelopeTenantMembersResponse
  status: 404
}

export type tenantGetMembersResponseSuccess = (tenantGetMembersResponse200) & {
  headers: Headers;
};
export type tenantGetMembersResponseError = (tenantGetMembersResponse400 | tenantGetMembersResponse401 | tenantGetMembersResponse403 | tenantGetMembersResponse404) & {
  headers: Headers;
};

export type tenantGetMembersResponse = (tenantGetMembersResponseSuccess | tenantGetMembersResponseError)

export const getTenantGetMembersUrl = (tenantId: string,) => {




  return `/api/tenants/${tenantId}/members`
}

export const useTenantGetMembersHook = (): (tenantId: string, options?: RequestInit) => Promise<tenantGetMembersResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string, options?: RequestInit) => {

        return customFetcher(getTenantGetMembersUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type tenantAddMemberResponse200 = {
  data: ApiEnvelopeTenantMemberDto
  status: 200
}

export type tenantAddMemberResponse400 = {
  data: ApiEnvelopeTenantMemberDto
  status: 400
}

export type tenantAddMemberResponse401 = {
  data: ApiEnvelopeTenantMemberDto
  status: 401
}

export type tenantAddMemberResponse403 = {
  data: ApiEnvelopeTenantMemberDto
  status: 403
}

export type tenantAddMemberResponse404 = {
  data: ApiEnvelopeTenantMemberDto
  status: 404
}

export type tenantAddMemberResponseSuccess = (tenantAddMemberResponse200) & {
  headers: Headers;
};
export type tenantAddMemberResponseError = (tenantAddMemberResponse400 | tenantAddMemberResponse401 | tenantAddMemberResponse403 | tenantAddMemberResponse404) & {
  headers: Headers;
};

export type tenantAddMemberResponse = (tenantAddMemberResponseSuccess | tenantAddMemberResponseError)

export const getTenantAddMemberUrl = (tenantId: string,) => {




  return `/api/tenants/${tenantId}/members`
}

export const useTenantAddMemberHook = (): (tenantId: string,
    addMemberRequest?: AddMemberRequest, options?: RequestInit) => Promise<tenantAddMemberResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string,
    addMemberRequest?: AddMemberRequest, options?: RequestInit) => {

        return customFetcher(getTenantAddMemberUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addMemberRequest)
  }
);
      }
  }


export type tenantRemoveMemberResponse200 = {
  data: ApiEnvelopeBoolean
  status: 200
}

export type tenantRemoveMemberResponse400 = {
  data: ApiEnvelopeBoolean
  status: 400
}

export type tenantRemoveMemberResponse401 = {
  data: ApiEnvelopeBoolean
  status: 401
}

export type tenantRemoveMemberResponse403 = {
  data: ApiEnvelopeBoolean
  status: 403
}

export type tenantRemoveMemberResponse404 = {
  data: ApiEnvelopeBoolean
  status: 404
}

export type tenantRemoveMemberResponseSuccess = (tenantRemoveMemberResponse200) & {
  headers: Headers;
};
export type tenantRemoveMemberResponseError = (tenantRemoveMemberResponse400 | tenantRemoveMemberResponse401 | tenantRemoveMemberResponse403 | tenantRemoveMemberResponse404) & {
  headers: Headers;
};

export type tenantRemoveMemberResponse = (tenantRemoveMemberResponseSuccess | tenantRemoveMemberResponseError)

export const getTenantRemoveMemberUrl = (tenantId: string,
    userId: string,) => {




  return `/api/tenants/${tenantId}/members/${userId}`
}

export const useTenantRemoveMemberHook = (): (tenantId: string,
    userId: string, options?: RequestInit) => Promise<tenantRemoveMemberResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string,
    userId: string, options?: RequestInit) => {

        return customFetcher(getTenantRemoveMemberUrl(tenantId,userId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type tenantUpdateMemberRoleResponse200 = {
  data: ApiEnvelopeTenantMemberDto
  status: 200
}

export type tenantUpdateMemberRoleResponse400 = {
  data: ApiEnvelopeTenantMemberDto
  status: 400
}

export type tenantUpdateMemberRoleResponse401 = {
  data: ApiEnvelopeTenantMemberDto
  status: 401
}

export type tenantUpdateMemberRoleResponse403 = {
  data: ApiEnvelopeTenantMemberDto
  status: 403
}

export type tenantUpdateMemberRoleResponse404 = {
  data: ApiEnvelopeTenantMemberDto
  status: 404
}

export type tenantUpdateMemberRoleResponseSuccess = (tenantUpdateMemberRoleResponse200) & {
  headers: Headers;
};
export type tenantUpdateMemberRoleResponseError = (tenantUpdateMemberRoleResponse400 | tenantUpdateMemberRoleResponse401 | tenantUpdateMemberRoleResponse403 | tenantUpdateMemberRoleResponse404) & {
  headers: Headers;
};

export type tenantUpdateMemberRoleResponse = (tenantUpdateMemberRoleResponseSuccess | tenantUpdateMemberRoleResponseError)

export const getTenantUpdateMemberRoleUrl = (tenantId: string,
    userId: string,) => {




  return `/api/tenants/${tenantId}/members/${userId}`
}

export const useTenantUpdateMemberRoleHook = (): (tenantId: string,
    userId: string,
    updateMemberRoleRequest?: UpdateMemberRoleRequest, options?: RequestInit) => Promise<tenantUpdateMemberRoleResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string,
    userId: string,
    updateMemberRoleRequest?: UpdateMemberRoleRequest, options?: RequestInit) => {

        return customFetcher(getTenantUpdateMemberRoleUrl(tenantId,userId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateMemberRoleRequest)
  }
);
      }
  }


export type tenantLeaveTenantResponse200 = {
  data: ApiEnvelopeBoolean
  status: 200
}

export type tenantLeaveTenantResponse400 = {
  data: ApiEnvelopeBoolean
  status: 400
}

export type tenantLeaveTenantResponse401 = {
  data: ApiEnvelopeBoolean
  status: 401
}

export type tenantLeaveTenantResponse403 = {
  data: ApiEnvelopeBoolean
  status: 403
}

export type tenantLeaveTenantResponse404 = {
  data: ApiEnvelopeBoolean
  status: 404
}

export type tenantLeaveTenantResponseSuccess = (tenantLeaveTenantResponse200) & {
  headers: Headers;
};
export type tenantLeaveTenantResponseError = (tenantLeaveTenantResponse400 | tenantLeaveTenantResponse401 | tenantLeaveTenantResponse403 | tenantLeaveTenantResponse404) & {
  headers: Headers;
};

export type tenantLeaveTenantResponse = (tenantLeaveTenantResponseSuccess | tenantLeaveTenantResponseError)

export const getTenantLeaveTenantUrl = (tenantId: string,) => {




  return `/api/tenants/${tenantId}/leave`
}

export const useTenantLeaveTenantHook = (): (tenantId: string, options?: RequestInit) => Promise<tenantLeaveTenantResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string, options?: RequestInit) => {

        return customFetcher(getTenantLeaveTenantUrl(tenantId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


